import Layout from "../components/layout"
import React from "react"
import SEO from "../components/seo"
import placeholder from '../images/shop-placeholder.png'
import styles from '../styles/shop.module.scss'

//Static Home Page
const shop = () => (
  <Layout>
    <SEO title="Shop" />
    <div className={styles.swag}>
      <h2>Shawna's Swag</h2>
      <div className={styles.swag_row}>
          <div className={styles.swag_row_item}>
            <img src={placeholder} />
            <div className={styles.swag_row_item_txt}>
            <h3>Title goes here</h3>
            <p>$19</p>
          </div>
          </div>
          <div className={styles.swag_row_item}>
          <img src={placeholder} />
          <div className={styles.swag_row_item_txt}>
            <h3>Title goes here</h3>
            <p>$19</p>
          </div>
          </div>
          <div className={styles.swag_row_item}>
          <img src={placeholder} />
          <div className={styles.swag_row_item_txt}>
            <h3>Title goes here</h3>
            <p>$19</p>
          </div>
          </div>

      </div>
    </div>
    <div className={styles.challenges}>
      <h2>Challenges</h2>
      <div className={styles.challenges_row}>
          <div className={styles.challenges_row_item}>
            <img src={placeholder} />
            <div className={styles.challenges_row_item_txt}>
            <h3>Title goes here</h3>
            <p>$19</p>
          </div>            
          </div>
          <div className={styles.challenges_row_item}>
            <img src={placeholder} />
            <div className={styles.challenges_row_item_txt}>
            <h3>Title goes here</h3>
            <p>$19</p>
          </div>          </div>
          <div className={styles.challenges_row_item}>
            <img src={placeholder} />
            <div className={styles.challenges_row_item_txt}>
            <h3>Title goes here</h3>
            <p>$19</p>
          </div>          </div>

      </div>
    </div>
  </Layout>
)

export default shop
